export default __webpack_public_path__ + "static/media/bgContact-movil.7ec9d455.png";